import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import api from '../api';
import { 
  FETCH_EXCHANGE_LIST,
  FETCH_QUOTE,
  FETCH_PATIENTS_LIST_TODAY
} from 'constants/ActionTypes';
import { userSignOut } from 'actions/Auth';
import { showExchangeLoader, showDashboardMessage, fetchExchangeListSuccess, showQuoteLoader, fetchQuoteSuccess, showPatientsListLoader, fetchPatientsListSuccess } from '../actions/Dashboard';

function* getExchangeList({ payload }) {
  try {
    const { date, currency } = payload;
    yield put(showExchangeLoader());
    const exchangeList = yield call(api.dashboardApi.getExchangeList, { date, currency});

    if (exchangeList.errorMessage) {
      yield put(showDashboardMessage(exchangeList.errorMessage, true));
    } else {
      yield put(fetchExchangeListSuccess(exchangeList));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showDashboardMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* getQuote() {
  try {
    yield put(showQuoteLoader());
    const quote = yield call(api.dashboardApi.getQuote, {});

    if (quote.errorMessage) {
      yield put(showDashboardMessage(quote.errorMessage, true));
    } else {
      yield put(fetchQuoteSuccess(quote));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showDashboardMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* getPatientsToday({ payload }) {
  try {
    yield put(showPatientsListLoader());
    const { date } = payload
    const authToken = localStorage.getItem('token');

    const quote = yield call(api.scheduleApi.getSchedule, { authToken, date });

    if (quote.errorMessage) {
      yield put(showDashboardMessage(quote.errorMessage, true));
    } else {
      yield put(fetchPatientsListSuccess(quote));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showDashboardMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

export function* fetchExchangeList() {
  yield takeEvery(FETCH_EXCHANGE_LIST, getExchangeList);
}

export function* fetchQuote() {
  yield takeEvery(FETCH_QUOTE, getQuote);
}

export function* fetchPatientsListToday() {
  yield takeEvery(FETCH_PATIENTS_LIST_TODAY, getPatientsToday);
}

export default function* rootSaga() {
  yield all([
    fork(fetchExchangeList),
    fork(fetchQuote),
    fork(fetchPatientsListToday)
  ]);
}



// WEBPACK FOOTER //
// ./sagas/Dashboard.js